module.exports = __webpack_public_path__ + "static/img/7g.573b1b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7g.jpg
// module id = jmmU
// module chunks = 0